import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import {
  importCSVFile,
  importHighRiskSupplementsListCSVFile, importIngredientsCleanUpListCSVFile,
  importSupplementsCleanUpCSVFile,
  importSynonymsListCSVFile,
} from '@api/medications';
import {
  IImportHighRiskSupplementsListResponse, IImportIngredientsCleanUpListResponse,
  IImportMedicationsResponse,
  IImportSupplementsCleanUpListResponse,
  IImportSynonymsListResponse,
} from '@interfaces/medications';

export const handleAdminImportMedications = createAsyncThunk<
  AxiosResponse<IImportMedicationsResponse>,
  { file: File }
>('adminImportMedications', ({ file }) => importCSVFile(file));

export const handleAdminImportSynonymsList = createAsyncThunk<
  AxiosResponse<IImportSynonymsListResponse>,
  { file: File }
>('adminImportSynonymsList', ({ file }) => importSynonymsListCSVFile(file));

export const handleAdminHighRiskSupplementsList = createAsyncThunk<
  AxiosResponse<IImportHighRiskSupplementsListResponse>,
  { file: File }
>('adminImportRiskSupplementsList', ({ file }) => importHighRiskSupplementsListCSVFile(file));

export const handleAdminImportSupplementsCleanUp = createAsyncThunk<
  AxiosResponse<IImportSupplementsCleanUpListResponse>,
  { file: File }
>('adminImportSupplementsCleanUp', ({ file }) => importSupplementsCleanUpCSVFile(file));

export const handleAdminImportIngredientsCleanUpList = createAsyncThunk<
  AxiosResponse<IImportIngredientsCleanUpListResponse>,
  { file: File }
>('adminImportIngredientsCleanUpList', ({ file }) => importIngredientsCleanUpListCSVFile(file));
